import type { ReactNode } from "react";
import { themeClasses, type Theme } from "@cw/design-tokens/theme";
import { ContainedSection, SectionHeader } from "../primitives/Section";
import { LinkRow, type LinkSpec } from "../primitives/Button";

export interface Step { title: string; body: ReactNode }
export function StepList({ eyebrow, heading, intro, steps, theme = "mist", links, id }: { eyebrow?: string; heading?: string; intro?: ReactNode; steps: Step[]; theme?: Theme; links?: LinkSpec[]; id?: string }) {
  const t = themeClasses(theme);
  return (
    <ContainedSection theme={theme} id={id}>
      <SectionHeader eyebrow={eyebrow} heading={heading} intro={intro} theme={theme} />
      <ol className="grid gap-6 md:grid-cols-3">
        {steps.map((s, i) => (
          <li key={s.title} className={`relative rounded-card ${t.card} p-7 shadow-card`}>
            <span aria-hidden="true" className="font-display text-4xl font-semibold tabular-nums text-signal">{String(i + 1).padStart(2, "0")}</span>
            <h3 className={`${t.heading} mt-4 font-display text-xl font-semibold`}>{s.title}</h3>
            <div className={`${t.body} mt-3 text-[15px] leading-relaxed ${t.prose}`}>{s.body}</div>
          </li>
        ))}
      </ol>
      <LinkRow links={links} theme={theme} className="mt-10" />
    </ContainedSection>
  );
}
